export function debug(data) {
  console.debug(data)
  return data
}

export function log(data) {
  console.log(data)
}

export function error(data) {
  console.error(data)
}

export function warn(data) {
  console.warn(data)
}

export function table(data) {
  const display = []
  for (const object of data) {
    const display_ = {}
    object.forEach((value, key) => (display_[key] = value))
    display.push(display_)
  }
  console.table(display)
}

export function clear() {
  console.clear()
}
